import React from 'react';
import PropTypes from 'prop-types';
import {
  FDPrimaryActionButton, FDSecondaryActionButton, FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import Spacer from 'Components/UI/Spacer';

const AssumptionLayout = ({
  onAdd,
  onDiscard,
}) => {
  const { resource } = useMetaLayoutContext();
  return (
    <FDStack direction="column" spacing={2} justifyContent="space-between">
      <MetaControlField attr={'startDate'} />
      <MetaControlField attr={'value'} />
      <Spacer />
      <FDStack direction={'row'} spacing={1}>
        <FDSecondaryActionButton
          label="Discard"
          onClick={() => onDiscard()}
          size="sm"
        />
        <FDPrimaryActionButton
          label="Save"
          onClick={() => onAdd(resource)}
          size="sm"
          disabled={!resource.isValid()}
        />
      </FDStack>
    </FDStack>
  );
};

AssumptionLayout.propTypes = {
  onAdd: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
};

export default AssumptionLayout;
